import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";

import { Button, MeatballMenu } from "@covertree/ui";

function AdditionalInterestCardSkeleton() {
  return (
    <Box
      position="relative"
      border="1px solid"
      borderRadius="10px"
      padding={3}
      borderColor="action.disabled">
      <Box position="absolute" top={16} right={16}>
        <MeatballMenu
          actionMenuItems={[]}
          border
          wrapperProps={{ width: "38px" }}
          disabled
        />
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={12} lg={5}>
          <Typography
            variant="subtitle2"
            color="textSecondary"
            sx={{ fontWeight: 300 }}>
            Name
          </Typography>
          <Skeleton variant="text" width={240} height={36} />
        </Grid>
        <Grid item xs={12} lg={5}>
          <Typography
            variant="subtitle2"
            color="textSecondary"
            sx={{ fontWeight: 300 }}>
            Type
          </Typography>
          <Skeleton variant="text" width={240} height={36} />
        </Grid>
        {[
          { label: "Address", width: 240 },
          { label: "Email", width: 240 },
          { label: "Loan / account #", width: 240 },
        ].map(({ label, width }) => (
          <Grid item xs={12} key={label}>
            <Typography
              variant="subtitle2"
              color="textSecondary"
              sx={{ fontWeight: 300 }}>
              {label}
            </Typography>
            <Skeleton variant="text" width={width} height={36} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export function AdditionalInterestsSkeleton() {
  return (
    <>
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button variant="outlined" size="small" disabled>
          Add additional interest
        </Button>
      </Box>
      <Grid container spacing={2}>
        {Array.from({ length: 3 }, (_, i) => (
          <Grid item xs={12} key={i}>
            <AdditionalInterestCardSkeleton />
          </Grid>
        ))}
      </Grid>
    </>
  );
}
